<template>
    <div id="nav">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-h6">
              {{ getUserData.name+" "+getUserData.surname }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <br />
              <v-img src="../../../assets/backgrounds/school-finance-graphic.png"></v-img>
              <br />
                {{ getUserData.department }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
  
        <v-divider></v-divider>
  
        <v-list
          dense
          nav
        >
          <v-list-item
            v-for="item in items"
            :key="item.title"
            link :to="item.path"
            :color="item.color"
          >
            <v-list-item-icon>
              <v-icon :color="item.color">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
    </div>
</template>

<script>
import auth from '../../../js/auth.js';

export default {
    name: "navigation",
    data() {
        return {
            items: [
              { 
                title: "Home", 
                icon: "mdi-home-outline", 
                path: "/home",
                color: "#2E7D32"
              },
              { 
                title: "Settings", 
                icon: "mdi-cog-outline", 
                path: "/config",
                color: "#8FABB3"
              },
              { 
                title: "Announcements", 
                icon: "mdi-bullhorn-outline", 
                path: "/announcements",
                color: "#D4C88D"
              },
              { 
                title: "Net Bill", 
                icon: "mdi-file-table-outline", 
                path: "/netbilladmin",
                color: "#8FB3A3"
              },
              { 
                title: "T2202A", 
                icon: "mdi-file-edit-outline", 
                path: "/t2202aadmin",
                color: "#98B38F"
              },
              { 
                title: "Student Data", 
                icon: "mdi-account-search-outline", 
                path: "/studentdata",
                color: "#BE977E"
              }
            ],
            right: null
        };
    },
    computed: {
      getUserData(){
        let user = auth.get_user();

        return user
      }
    },
    methods: {
      //Adds ITS only page if the user is from ITS Department
      allowITAccess(){
        const that = this;
        let user = auth.get_user();

        if(user.department.match(/^Information Technology Services/i)){
          var its = {
                title: "ITS",
                icon: "mdi-crown-outline",
                path: "/itsonly",
                color: "#977EBE"
              }
          that.items.push(its)
        }
      }
    },
    created(){
      const that = this;
      that.allowITAccess();
    }
}
</script>